// src/SpecialtyModal.js - NUOVO FILE

import React, { useState, useEffect } from 'react';

export function SpecialtyModal({ specialtyData, onSave, onClose }) {
    const [name, setName] = useState('');
    const [color, setColor] = useState('#84A9C0');

    useEffect(() => {
        if (specialtyData) {
            setName(specialtyData.name || '');
            setColor(specialtyData.color || '#84A9C0');
        }
    }, [specialtyData]);

    const handleSave = () => {
        if (name.trim() === '') {
            alert('Il nome della specialistica è obbligatorio.');
            return;
        }
        onSave({
            id: specialtyData?.id,
            name: name.trim(),
            color: color,
        });
    };

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>{specialtyData ? 'Modifica Specialistica' : 'Nuova Specialistica'}</h3>

                {/* --- INIZIO BLOCCO MODIFICATO --- */}
                <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-end', textAlign: 'left', marginTop: '25px' }}>
                    <div style={{ flex: 3 }}> {/* Campo nome più largo */}
                        <label htmlFor="spec-name" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Nome Specialistica</label>
                        <input id="spec-name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div style={{ flex: 1 }}> {/* Campo colore più stretto */}
                        <label htmlFor="spec-color" style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Colore</label>
                        <input id="spec-color" type="color" value={color} onChange={(e) => setColor(e.target.value)} style={{ width: '100%', height: '38px', padding: '2px' }} />
                    </div>
                </div>
                {/* --- FINE BLOCCO MODIFICATO --- */}

                <div>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '30px' }}>Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}